export const ADMINS_LIST_TABLE_LABELS = [
  {
    accessor: 'name',
    isSortable: true,
    label: 'Name',
  },
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Created',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Role',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Email Address',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Mobile Number',
  },
];

export const LAWYERS_LIST_TABLE_LABELS = [
  {
    accessor: 'name',
    isSortable: true,
    label: 'Name',
  },
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Created',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Role',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Email Address',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Mobile Number',
  },
];

export const CASES_LIST_TABLE_LABELS = [
  {
    accessor: 'name',
    isSortable: true,
    label: 'Case',
  },
  {
    accessor: 'referenceId',
    isSortable: false,
    label: 'Reference ID',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Plaintiff',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Defendant',
  },
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: 'filedAt',
    isSortable: true,
    label: 'Filed',
  },
  // {
  //   accessor: 'sol',
  //   isSortable: true,
  //   label: 'SOL',
  // },
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Created',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Settled Amount',
  },
];

export const VENDORS_LIST_TABLE_LABELS = [
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: 'name',
    isSortable: true,
    label: 'Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Vendor Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Preferred Payment Methods',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Vendor Account Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: '',
  },
];

export const VENDOR_DOCUMENT_TABLE_LABELS = [
  {
    accessor: 'fileName',
    isSortable: false,
    label: 'File Name',
  },
  {
    accessor: 'fileSize',
    isSortable: false,
    label: 'File Size',
  },
  {
    accessor: 'uploadedBy',
    isSortable: false,
    label: 'Uploaded By',
  },
  {
    accessor: 'uploadedAt',
    isSortable: false,
    label: 'Uploaded At',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Actions',
  }
];


export const DEDUCTION_RECOVERIES_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Date Received',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Reason',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Note',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Actions',
  },
];

export const DEDUCTIONS_LIST_TABLE_LABELS = [
  {
    accessor: 'referenceId',
    isSortable: true,
    label: 'Case Reference ID',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Plaintiff',
  },
  // {
  //   accessor: '',
  //   isSortable: false,
  //   label: 'Defendant',
  // },
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Vendor',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'paidAt',
    isSortable: true,
    label: 'Payment Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Actions',
  },
];

export const getSettlementsListTableLabels = (showUserOnboardingDetails: boolean, showApprovalFlow: boolean) => {
  const labels = [
    {
      accessor: '',
      isSortable: false,
      label: 'Status',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Case Reference ID',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settlement Type',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Client',
    },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Defendant',
    // },
    {
      accessor: 'updatedAt',
      isSortable: true,
      label: 'Updated',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settled Amount',
    },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Attorneys Fees',
    // },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Deductions',
    // },

    ...(showApprovalFlow ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Approval Status',
      },
    ] : []),
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Onboarding Status',
      },
    ] : []),
    {
      accessor: '',
      isSortable: false,
      label: 'Distribution',
    },
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Actions',
      },
    ] : []),
    // {
    //   accessor: 'paidAt',
    //   isSortable: true,
    //   label: 'Payment Date',
    // },
  ];
  return labels;
};

export const getDashboardSettlementsTableLabels = (showUserOnboardingDetails: boolean, showApprovalFlow: boolean) => {
  const labels = [
    {
      accessor: '',
      isSortable: false,
      label: 'Status',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Case Reference ID',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settlement Type',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Client',
    },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Defendant',
    // },
    {
      accessor: 'updatedAt',
      isSortable: true,
      label: 'Updated',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settled Amount',
    },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Attorneys Fees',
    // },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Deductions',
    // },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Net Settlement',
    // },
    ...(showApprovalFlow ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Approval Status',
      },
    ] : []),
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Onboarding Status',
      },
    ] : []),
    {
      accessor: '',
      isSortable: false,
      label: 'Distribution',
    },
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Actions',
      },
    ] : []),
    // {
    //   accessor: 'paidAt',
    //   isSortable: true,
    //   label: 'Payment Date',
    // },
  ];
  return labels;
};

export const ATTORNEY_LIST_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Action',
  },
];

export const NET_SETTLEMENT_LIST_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Client Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Action',
  },
];

export const LIENS_LIST_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Vendor',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Intent',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Payment Method',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Action',
  },
];

export const EXPENSE_LIST_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Vendor',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Intent',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Payment Method',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Action',
  },
];

export const DOCUMENTS_LIST_TABLE_LABELS = [
  {
    accessor: 'plaintiff',
    isSortable: true,
    label: 'Client',
  },
  {
    accessor: 'sentAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'File',
  },
];

export const SIGNATURES_LIST_TABLE_LABELS = [
  {
    accessor: 'plaintiff',
    isSortable: true,
    label: 'Client',
  },
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Id',
  },
];

export const DATA_LIST_TABLE_LABELS = [
  {
    accessor: 'client',
    isSortable: true,
    label: 'Client',
  },
  {
    accessor: 'sentAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Case Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Items',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Data File',
  },
];

export const getFirmClientsListTableLabels = (showUserOnboardingDetails: boolean) => {
  const labels = [
    {
      accessor: 'name',
      isSortable: true,
      label: 'Name',
    },
    {
      accessor: 'referenceId',
      isSortable: false,
      label: 'Reference ID',
    },
    ...(showUserOnboardingDetails ? [
      {
        accessor: 'onboardingStatus',
        isSortable: false,
        label: 'Onboarding Status',
      },
    ] : []),
    {
      accessor: 'email',
      isSortable: false,
      label: 'Email',
    },
    {
      accessor: 'updatedAt',
      isSortable: true,
      label: 'Updated',
    },
    // {
    //   accessor: 'createdAt',
    //   isSortable: true,
    //   label: 'Created',
    // },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Status',
    // },
    {
      accessor: '',
      isSortable: false,
      label: 'Active Cases',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settled Amounts',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Net Settlements',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Wallet Balance',
    },
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Actions',
      },
    ] : []),
  ];
  return labels;
};

export const FIRM_DEFENDANTS_LIST_TABLE_LABELS = [
  {
    accessor: 'name',
    isSortable: true,
    label: 'Name',
  },
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Active Cases',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Settled Amounts',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Net Settlements',
  },
];

export const FIRM_LAWYERS_LIST_TABLE_LABELS = [
  {
    accessor: 'name',
    isSortable: true,
    label: 'Name',
  },
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Created',
  },
  {
    accessor: 'role',
    isSortable: false,
    label: 'Role',
  },
  {
    accessor: 'status',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'email',
    isSortable: false,
    label: 'Email Address',
  },
  {
    accessor: 'phone',
    isSortable: false,
    label: 'Mobile Number',
  },
];

export const FIRM_DOCUMENTS_LIST_TABLE_LABELS = [
  {
    accessor: 'plaintiff',
    isSortable: true,
    label: 'Client',
  },
  {
    accessor: 'sentAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'File',
  },
];

export const CASES_DATA_REQUEST_LIST_TABLE_LABELS = [
  {
    accessor: 'sentAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Case Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Items',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Data File',
  },
];

export const FIRM_SIGNATURE_LIST_TABLE_LABELS = [
  {
    accessor: 'plaintiff',
    isSortable: true,
    label: 'Client',
  },
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Id',
  },
];

export const CASES_DEDUCTIONS_LIST_TABLE_LABELS = [
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Assignment',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'paidAt',
    isSortable: true,
    label: 'Payment Date',
  },
];

export const getCasesSettlementsListTableLabels = (showUserOnboardingDetails: boolean, showApprovalFlow: boolean) => {
  const labels = [
    {
      accessor: '',
      isSortable: false,
      label: 'Status',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Case Reference ID',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settlement Type',
    },
    {
      accessor: 'updatedAt',
      isSortable: true,
      label: 'Updated',
    },
    {
      accessor: '',
      isSortable: false,
      label: 'Settled Amount',
    },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Attorneys Fees',
    // },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Deductions',
    // },
    // {
    //   accessor: '',
    //   isSortable: false,
    //   label: 'Net Settlement',
    // },
    ...(showApprovalFlow ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Approval Status',
      },
    ] : []),
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Onboarding Status',
      },
    ] : []),
    {
      accessor: '',
      isSortable: false,
      label: 'Distribution',
    },
    ...(showUserOnboardingDetails ? [
      {
        accessor: '',
        isSortable: false,
        label: 'Actions',
      },
    ] : []),
    // {
    //   accessor: 'paidAt',
    //   isSortable: true,
    //   label: 'Payment Date',
    // },
  ];
  return labels;
};

export const CASES_DOCUMENTS_LIST_TABLE_LABELS = [
  {
    accessor: 'sentAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'File',
  },
];

export const CASES_SIGNATURE_LIST_TABLE_LABELS = [
  {
    accessor: 'createdAt',
    isSortable: true,
    label: 'Request Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completion Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Completion Time',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Document Id',
  },
];

export const FIRM_TRANSACTION_LIST_TABLE_LABELS = [
  {
    accessor: 'lastUpdatedOn',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Transaction ID',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Case Reference ID',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Plaintiff Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Memo',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Destination Account Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Running Balance',
  },
];

export const FIRM_BANKING_UNRESTRICTED_ACCOUNTS_LIST_TABLE_LABELS = [
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account Number',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Routing Number',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Verification Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: '',
  },
];

export const FIRM_BANKING_TRUST_ACCOUNTS_LIST_TABLE_LABELS = [
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account Number',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Routing Number',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Account Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Verification Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: '',
  },
];

export const DATA_FILE_MANAGER_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Uploaded',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'File Name',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'File Type',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'By',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
];

export const VENDOR_FILE_UPLOAD_HISTORY_TABLE_LABELS = [
  {
    accessor: 'fileName',
    isSortable: false,
    label: 'File Name',
  },
  {
    accessor: 'status',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: 'totalRows',
    isSortable: false,
    label: 'Total Rows',
  },
  {
    accessor: 'successCount',
    isSortable: false,
    label: 'Success Count',
  },
  {
    accessor: 'failureCount',
    isSortable: false,
    label: 'Failure Count',
  },
  {
    accessor: 'startedAt',
    isSortable: true,
    label: 'Started At',
  },
  {
    accessor: 'completedAt',
    isSortable: true,
    label: 'Completed At',
  },
  {
    accessor: 'errorFile',
    isSortable: false,
    label: 'Error File',
  },
];

export const VENDOR_PAYMENT_HISTORY_LIST_TABLE_LABELS = [
  {
    accessor: 'updatedAt',
    isSortable: true,
    label: 'Updated',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Case Reference ID',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Plaintiff',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Method',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Nickname',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Amount',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Netsuite',
  }
];

export const CASE_LEDGER_LIST_TABLE_LABELS = [
  {
    accessor: '',
    isSortable: false,
    label: 'Date',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Description',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Category',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Credit',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Debit',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Balance',
  },
  {
    accessor: '',
    isSortable: false,
    label: 'Status',
  },
];
